export type WorkspaceCode = 'english' | 'math' | 'programming' | 'iq' | 'eq' | 'finance'
export type WorkspaceTone = 'blue' | 'orange' | 'violet' | 'emerald' | 'rose' | 'amber'

export interface WorkspaceDefinition {
  code: WorkspaceCode
  name: string
  description: string
  path: string
  available: boolean
  tone: WorkspaceTone
}

export const workspaces: WorkspaceDefinition[] = [
  { code: 'english', name: 'Tiếng Anh', description: 'Học qua bài đọc và luyện tập', path: '/english', available: true, tone: 'blue' },
  { code: 'math', name: 'Toán', description: 'Rèn tư duy và kỹ năng tính toán', path: '/math', available: false, tone: 'orange' },
  { code: 'programming', name: 'Lập trình', description: 'Học cách xây dựng sản phẩm số', path: '/programming', available: false, tone: 'violet' },
  { code: 'iq', name: 'IQ Logic', description: 'Luyện suy luận và giải quyết vấn đề', path: '/iq-logic', available: false, tone: 'emerald' },
  { code: 'eq', name: 'Trí tuệ cảm xúc EQ', description: 'Hiểu cảm xúc và kết nối tốt hơn', path: '/eq', available: false, tone: 'rose' },
  { code: 'finance', name: 'Tài chính', description: 'Xây dựng thói quen tài chính lành mạnh', path: '/finance', available: false, tone: 'amber' },
]

const STORAGE_KEY = 'hocnhe:last-workspace'

export function readLastWorkspace() {
  try {
    const code = window.localStorage.getItem(STORAGE_KEY)
    return workspaces.find(workspace => workspace.code === code && workspace.available) ?? null
  } catch {
    return null
  }
}

export function rememberWorkspace(code: WorkspaceCode) {
  try { window.localStorage.setItem(STORAGE_KEY, code) } catch { return }
}

export function workspaceFromPath(pathname: string) {
  return workspaces.find(workspace => pathname === workspace.path || pathname.startsWith(`${workspace.path}/`)) ?? null
}
